export default __webpack_public_path__ + "static/media/callback-bg.63686f59.png";